import { BadgeColor } from 'types';
import { Flex } from 'components/flex';
import { Icon } from 'components/icon';
import { Badge } from 'components/badge';
import { Dialog } from 'components/dialog';
import { formatPrice } from 'utils/helpers';
import imagePlaceholder from 'assets/images/no-image-placeholder.jpg';

import * as Styles from './styles';
import { CartItemProps } from './types';

export const CartItem = ({
  value,
  authUser,
  hideDeleteCart,
  onConfirmRemove,
  hasCreditPayment,
}: CartItemProps) => (
  <Styles.Block key={value.id}>
    <Flex alignItems="flex-start" justifyContent="space-between">
      <Flex gap={16} alignItems="center">
        <Styles.StyledImage
          width={56}
          height={56}
          objectFit="cover"
          src={value.product?.photoUrl || imagePlaceholder}
        />
        <Flex flexDirection="column">
          <p>{value.product?.name}</p>
          <p>
            {value.quantity} x {formatPrice(value.price)}
          </p>
          <Flex gap={8} flexWrap="wrap">
            {value.priceApprovalId && (
              <Badge text="Approved" styleType={BadgeColor.Green} />
            )}
            {value.isShipping && (
              <Badge
                text="Shipping"
                icon={<Icon.Delivery />}
                styleType={BadgeColor.TetrieryBlue}
              />
            )}
            {value.isExchange && (
              <Badge text="Exchange" styleType={BadgeColor.TetrieryBlue} />
            )}
            {value.isDamaged && (
              <Badge text="Damaged" styleType={BadgeColor.SecondaryRed} />
            )}
          </Flex>
          {value?.notes && (
            <p>
              <span className="semibold">Comment:</span> {value.notes}
            </p>
          )}
        </Flex>
      </Flex>
      {!hideDeleteCart && (
        <Dialog
          title="Delete product"
          trigger={
            <Styles.StyledDeleteButtonWithRef disabled={hasCreditPayment} />
          }
          text={
            <>
              You are going to delete product{' '}
              <span className="semibold">{value.product?.name}</span> Are you
              sure you want to do that?
            </>
          }
          onConfirm={() => {
            console.log('[CART] remove product', {
              cartId: value.id,
              userId: authUser?.id,
              name: value?.product?.name,
            });
            onConfirmRemove?.(value.id);
          }}
        />
      )}
    </Flex>
  </Styles.Block>
);
